module.exports = __webpack_public_path__ + "static/img/qm06_wrap_bg.41fc55f3.png";